/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkTimerecord } from '../models/work-timerecord';
import { WorkUpdateTimerecordDto } from '../models/work-update-timerecord-dto';

@Injectable({ providedIn: 'root' })
export class WorkTimerecordsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `timerecordsV2ControllerFindById()` */
  static readonly TimerecordsV2ControllerFindByIdPath = '/v2/timerecords/{id}';

  /**
   * Required permissions: timerecords:read, timerecorddetails:read, timerecords:admin, timerecorddetails:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordsV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTimerecord>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordsV2Service.TimerecordsV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTimerecord>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read, timerecorddetails:read, timerecords:admin, timerecorddetails:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordsV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTimerecord> {
    return this.timerecordsV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTimerecord>): WorkTimerecord => r.body)
    );
  }

  /** Path part for operation `timerecordsV2ControllerUpdate()` */
  static readonly TimerecordsV2ControllerUpdatePath = '/v2/timerecords/{id}';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTimerecordDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordsV2Service.TimerecordsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  timerecordsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTimerecordDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.timerecordsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `timerecordsV2ControllerStartGenerationByUserIdAndYear()` */
  static readonly TimerecordsV2ControllerStartGenerationByUserIdAndYearPath = '/v2/timerecords/startGeneration/byUserId/{userId}/{year}';

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordsV2ControllerStartGenerationByUserIdAndYear()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerStartGenerationByUserIdAndYear$Response(
    params: {
      userId: number;
      year: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordsV2Service.TimerecordsV2ControllerStartGenerationByUserIdAndYearPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('year', params.year, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: timerecords:read, timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordsV2ControllerStartGenerationByUserIdAndYear$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerStartGenerationByUserIdAndYear(
    params: {
      userId: number;
      year: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.timerecordsV2ControllerStartGenerationByUserIdAndYear$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `timerecordsV2ControllerStartGenerationForAllActiveUsers()` */
  static readonly TimerecordsV2ControllerStartGenerationForAllActiveUsersPath = '/v2/timerecords/startGenerationForAllActiveUsers';

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `timerecordsV2ControllerStartGenerationForAllActiveUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerStartGenerationForAllActiveUsers$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTimerecordsV2Service.TimerecordsV2ControllerStartGenerationForAllActiveUsersPath, 'post');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: timerecords:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `timerecordsV2ControllerStartGenerationForAllActiveUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  timerecordsV2ControllerStartGenerationForAllActiveUsers(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.timerecordsV2ControllerStartGenerationForAllActiveUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
